import { useContext } from 'react';
import { useIntl } from 'react-intl';
import { useMutation } from '@apollo/client';
import FeedbackContext from '../components/feedbackContext/FeedbackContext';
import { CREATE_COLOR, DELETE_COLOR } from './actionTypes';

const useCreateColorUser = (onCompletedCreateColor = null, onCompleteDeleteColor = null) => {
    const intl = useIntl();
    const { setFeedbackOnStage } = useContext(FeedbackContext);
    const [createColor, { loading: isLoadingCreateColor, error: isErrorCreateColor }] = useMutation(
        CREATE_COLOR,
        {
            notifyOnNetworkStatusChange: true,
            onCompleted: onCompletedCreateColor,
        },
    );

    const [deleteColor, { loading: isLoadingDeleteColor, error: isErrorDeleteColor }] = useMutation(
        DELETE_COLOR,
        {
            notifyOnNetworkStatusChange: true,
            onCompleted: onCompleteDeleteColor,
        },
    );

    const withFailureFeedback = (mutation) => async (options) => {
        try {
            return await mutation(options);
        } catch (error) {
            setFeedbackOnStage({
                label: intl.formatMessage({ id: 'library.save.error' }),
                type: 'danger',
                show: true,
            });
            throw error;
        }
    };

    return {
        createColor: withFailureFeedback(createColor),
        isLoadingCreateColor,
        isErrorCreateColor,
        deleteColor: withFailureFeedback(deleteColor),
        isLoadingDeleteColor,
        isErrorDeleteColor,
    };
};

export default useCreateColorUser;
